/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing the 5-minute break itself, so a quick breather doesn't stretch into twenty minutes.`)
};

const es_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar el propio descanso de 5 minutos, para que una pausa breve no se estire a veinte minutos.`)
};

const de_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die 5-minütige Pause selbst stoppen, damit eine kurze Verschnaufpause nicht zu zwanzig Minuten wird.`)
};

const nl_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De pauze van 5 minuten zelf timen, zodat een korte adempauze niet uitloopt tot twintig minuten.`)
};

const fr_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronométrer la pause de 5 minutes elle-même, pour qu’une courte respiration ne se transforme pas en vingt minutes.`)
};

const it_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrare la pausa di 5 minuti stessa, così una breve boccata d'aria non si trasforma in venti minuti.`)
};

const pt_br2_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar a própria pausa de 5 minutos, para que uma respirada rápida não se estenda por vinte minutos.`)
};

const pt_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar a própria pausa de 5 minutos, para que um breve descanso não se prolongue por vinte minutos.`)
};

const ja_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5分間の休憩そのものを計測し、ちょっとした休憩が20分に延びないようにする。`)
};

const zh_timer_pomodoro_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为5分钟的休息本身计时，避免短暂的喘息变成二十分钟。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_use3", locale)
	if (locale === "en") return en_timer_pomodoro_use3(inputs)
	if (locale === "es") return es_timer_pomodoro_use3(inputs)
	if (locale === "de") return de_timer_pomodoro_use3(inputs)
	if (locale === "nl") return nl_timer_pomodoro_use3(inputs)
	if (locale === "fr") return fr_timer_pomodoro_use3(inputs)
	if (locale === "it") return it_timer_pomodoro_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_use3(inputs)
	if (locale === "pt") return pt_timer_pomodoro_use3(inputs)
	if (locale === "ja") return ja_timer_pomodoro_use3(inputs)
	return zh_timer_pomodoro_use3(inputs)
};